<template>
    <div>
        <block v-if="loading"></block>
        <div class="d-flex flex-wrap align-self-center justify-end mb-3">
            <v-btn class="btn-save" @click="getAllInvoices()">Recargar historial
            </v-btn>
        </div>
        <div>
            <GeneralFilter class="backgroundGlobal border-boxGlobal"  :search="filter" :filterEndpoint="$API.invoices.getInvoicesFilteringNotBilled" @emptyFilter="getAllInvoices" @filtered="filterHandler">
                <div class="d-flex flex-wrap gap-2 mb-3 px-4" v-if="UseRecurringTemplates">
                    <v-chip
                        v-if="invoicesCount.all > 0"
                        :color="statusFilter === 'all' ? 'blue darken-2' : 'blue lighten-4'"
                        :dark="statusFilter === 'all'"
                        @click="statusFilter = 'all'"
                        class="filter-chip"
                    >
                        TOTAL: {{ invoicesCount.all }}
                    </v-chip>
                    <v-chip
                        v-if="invoicesCount.overdue > 0"
                        :color="statusFilter === 'overdue' ? 'red darken-3' : 'red lighten-4'"
                        :dark="statusFilter === 'overdue'"
                        @click="statusFilter = 'overdue'"
                        class="filter-chip"
                    >
                        VENCIDAS: {{ invoicesCount.overdue }}
                    </v-chip>
                    <v-chip
                        v-if="invoicesCount.today > 0"
                        :color="statusFilter === 'today' ? 'yellow darken-3' : 'yellow lighten-3'"
                        :dark="statusFilter === 'today'"
                        @click="statusFilter = 'today'"
                        class="filter-chip"
                    >
                        VENCE HOY: {{ invoicesCount.today }}
                    </v-chip>
                    <v-chip
                        v-if="invoicesCount.soon > 0"
                        :color="statusFilter === 'soon' ? 'orange darken-3' : 'orange lighten-3'"
                        :dark="statusFilter === 'soon'"
                        @click="statusFilter = 'soon'"
                        class="filter-chip"
                    >
                        POR VENCER: {{ invoicesCount.soon }}
                    </v-chip>
                    <v-chip
                        v-if="invoicesCount.valid > 0"
                        :color="statusFilter === 'valid' ? '#095891' : '#3498db'"
                        :text-color="statusFilter === 'valid' ? 'white' : 'white'"
                        :dark="statusFilter === 'valid'"
                        @click="statusFilter = 'valid'"
                        class="filter-chip"
                    >
                        VIGENTES: {{ invoicesCount.valid }}
                    </v-chip>
                </div>
                <DxDataGrid :scrolling="{useNative:true}" width="100%" :data-source="filteredInvoices" key-expr="ID_Invoice"
                  @exporting="onExporting" :paging="{ enabled: false }" style="max-height: 600px;"
                  :on-cell-prepared="onCellPrepared"
                                    :on-row-prepared="onRowPrepared"
                >
                    <DxColumnFixing :enabled="true" />
                    <DxExport :enabled="true" />
                    <!--DxPaging :page-size="10"/-->
                    <DxColumn 
                        :width="80" 
                        cell-template="show-template" 
                        caption=""
                        :fixed="true" 
                        :fixed-position="'left'"
                    ></DxColumn>
                    <DxColumn :width="200" data-field="ID_Invoice" caption="ID de factura"></DxColumn>
                    <DxColumn :width="130" data-field="InvoiceDate" caption="Fecha de creación"></DxColumn>
                    <DxColumn :width="130" data-field="Hour" caption="Hora de creación"></DxColumn>
                    <DxColumn :width="170" data-field="ID_Customer" caption="ID de cliente o negocio"></DxColumn>
                    <DxColumn :width="250" data-field="InvoiceName" caption="Nombre Legal"></DxColumn>
                    <DxColumn :width="250" data-field="ComercialName" caption="Nombre Comercial"></DxColumn>
                    <DxColumn :width="250" cell-template="tipos-facturas" caption="Tipo de factura"></DxColumn>
                    <template #tipos-facturas="{ data }">
                        {{ data.data.InvoiceType == "CCF" ? "COMPROBANTE CRÉDITO FISCAL" : "" }}
                        {{ data.data.InvoiceType == "FCF" ? "FACTURA CONSUMIDOR FINAL" : "" }}
                        {{ data.data.InvoiceType == "DNC" ? "NOTA DE CRÉDITO" : "" }}
                        {{ data.data.InvoiceType == "DND" ? "NOTA DE DÉBITO" : "" }}
                        {{ data.data.InvoiceType == "DNR" ? "NOTA DE REMISIÓN" : "" }}
                        {{ data.data.InvoiceType == "FNS" ? "FACTURA DE SUJETO EXCLUIDO" : "" }}
                        {{ data.data.InvoiceType == "FEX" ? "FACTURA DE EXPORTACIÓNA" : "" }}
                        {{ data.data.InvoiceType == "DNC" ? "COMPROBANTE DE DONACIÓN" : "" }}
                    </template>
                    <DxColumn :width="250" data-field="FullName" caption="Usuario"></DxColumn>
                    <DxColumn :width="250" data-field="FullNameSeller" caption="Vendedor"></DxColumn>
                    <DxColumn 
                        :width="'auto'" 
                        data-field="InvoiceTotalPagarToShow" 
                        caption="Total de la Factura"
                        :fixed="true" 
                        :fixed-position="'right'"
                    ></DxColumn>
                    <template #show-template="{data}">
                        <div>
                            <a href="#" class="mx-1" @click.prevent.stop="showInvoiceModal(data)">
                                <v-icon color="primary">mdi-eye</v-icon>
                            </a>
                            <a v-if="data?.key?.includes('COM') && posrestaurant" href="#" class="mx-1" @click.prevent.stop="showComandaModal(data)">
                                <v-icon color="primary">mdi-file</v-icon>
                            </a>
                        </div>
                    </template>
                </DxDataGrid>
            </GeneralFilter>
        </div>
        <!-- Show Invoice Modal -->
        <v-dialog v-model="showModal" scrollable :max-width="$vuetify.breakpoint.smAndDown ? '90%':'75%'">
            <v-card v-if="showInvoice" height="100%">
                <!--v-card-title class="text-h5">
                    Notas Internas de la Factura
                </v-card-title-->

                <invoice-details :hideQr="true" :hasPrintButtom="true" :hasDeleteBtn="true" :invoice="showInvoice.data" :key="showInvoice.data.ID_Invoice"
                                 @close="hideModal" @billNow="billNow"
                                 @updateCustomerData="updatedCustomerData"></invoice-details>

            </v-card>
        </v-dialog>

        <alerts
            v-if="alert.show"
            v-on:close_alert="() => { alert.show = false }"
            v-on:accept_alert="alert.options.alertAccept"
            :properties="alert"
        >
        </alerts>
    </div>
</template>

<script>
    import {DxDataGrid, DxColumn, DxExport, DxColumnFixing } from 'devextreme-vue/data-grid';
    import GeneralFilter from '../../components/GeneralFilter.vue';
    import { printToExcel } from "@/helpers/printToexcel";
    import { numberWithCommas } from '../../helpers/money';

    import InvoiceDetails from "./InvoiceDetails";
    import Block from "@/components/Block";
    import Alerts from "@/components/Alerts";
    import { imprimirFactura } from '../../utils/printInvoice';
    import moment from "moment";

    export default {
        name: "Bill",
        components: {
            DxColumn, 
            DxDataGrid, 
            DxColumnFixing,
            GeneralFilter, 
            InvoiceDetails, 
            Block , 
            DxExport,
            Alerts
        },
        data() {
            return {
                loading: false,
                form: {},
                showModal: false,
                filter: {
                    //pay: true,
                    ID_Branch: null,
                    ID_Business: null,
                    status: 0,
                    istemplate: 0,
                    isquote: 0,
                    isfinance: 0,
                },
                invoices: null,
                showInvoice: null,
                posrestaurant: JSON.parse(localStorage.getItem("user")).posrestaurant || 0,
                UseRecurringTemplates: JSON.parse(localStorage.getItem("user")).userecurringtemplates || 0,
                orderAndPrint: false,
                statusFilter: 'all',
                alert: {
                    type: "warning",
                    show: false,
                    header: "",
                    body: "",
                },
            }
        },
        mounted() {
            this.filter.ID_Branch = JSON.parse(localStorage.getItem("user")).branch;
            this.filter.ID_Business = JSON.parse(localStorage.getItem("user")).businessid;

            this.getAllInvoices()
        },
        computed: {
            columnWidth() {
                return this.$vuetify.breakpoint.smAndDown ? '150px' : "auto !important";
            },
            filteredInvoices() {
                if (!this.invoices || this.statusFilter === 'all') {
                    return this.invoices;
                }
                
                return this.invoices.filter(invoice => {
                    const status = this.getInvoiceStatus(invoice);
                    return status === this.statusFilter;
                });
            },
            invoicesCount() {
                if (!this.invoices) {
                    return { all: 0, overdue: 0, today: 0, soon: 0, valid: 0 };
                }
                
                const counts = {
                    all: this.invoices.length,
                    overdue: 0,
                    today: 0,
                    soon: 0,
                    valid: 0
                };
                
                this.invoices.forEach(invoice => {
                    const status = this.getInvoiceStatus(invoice);
                    if (counts[status] !== undefined) {
                        counts[status]++;
                    }
                });
                
                return counts;
            }
        },
        methods: {
            getInvoiceStatus(invoice) {
                const targetDate = invoice?.InvoiceDateDF;
                if (!targetDate) {
                    return 'valid';
                }
                
                const today = moment().startOf('day');
                const target = moment(targetDate, "YYYY-MM-DD").startOf('day');
                const diffDays = target.diff(today, 'days');
                
                if (diffDays < 0) return 'overdue';
                if (diffDays === 0) return 'today';
                if (diffDays <= 7) return 'soon';
                return 'valid';
            },
            normalizeDateToMidnight(date) {
                const normalized = new Date(date);
                normalized.setHours(0, 0, 0, 0);
                return normalized;
            },
            getDateHighlightConfig(rowData) {
                const targetDate = rowData?.InvoiceDateDF;
                if (!targetDate) {
                    return null;
                }
                const today = moment().startOf('day');
                const target = moment(targetDate, "YYYY-MM-DD").startOf('day');
                const diffDays = target.diff(today, 'days');
                if (!this.UseRecurringTemplates) {
                    return { backgroundColor: '#FFF', };
                }
                if (diffDays < 0) {
                    return { backgroundColor: '#FFEBEE', borderColor: '#D32F2F', textColor: '#B71C1C' }; // Vencido
                }
                if (diffDays === 0) {
                    return { backgroundColor: '#FFF' }; // Hoy
                }
                if (diffDays <= 7) {
                    return { backgroundColor: '#FFF' }; // Por vencer
                }
                return { backgroundColor: '#FFF', }; // Vigente
            },
            onRowPrepared(e) {
                if (e.rowType !== 'data') {
                    return;
                }

                const highlight = this.getDateHighlightConfig(e.data);
                if (!highlight) {
                    return;
                }

                const rowElement = e.rowElement && e.rowElement.get ? e.rowElement.get(0) : e.rowElement;
                if (!rowElement) {
                    return;
                }

                rowElement.style.borderLeft = `4px solid ${highlight.borderColor}`;

                const rowCells = rowElement.querySelectorAll('td');
                rowCells.forEach((cell) => {
                    cell.style.backgroundColor = highlight.backgroundColor;
                    cell.style.color = highlight.textColor;
                });
            },
            onCellPrepared(e) {
                if (e.column.dataField === 'InvoiceTotalPagarToShow') {
                    e.cellElement.style.backgroundColor = '#FAFAFA';
                    
                    if (e.rowType === 'data') {
                        e.cellElement.style.color = '#00897B';
                        e.cellElement.style.fontWeight = 'bold';
                    }
                }
            },
            async updatedCustomerData(message) {
                this.hideModal()
                this.showAlert("success", "Actualizado", message, {
                    alertAccept: async () => {}
                })
            },
            formatInvoiceFields() {
                // const dictionary = {
                //     '00': "Prueba",
                //     '01': "Producción"
                // };
                const { Currency } = JSON.parse(localStorage.getItem('branch'));
                for(const index in this.invoices) {
                    // const { IdentificacionHorEmi, InvoiceType, SystemDateInsert, IdentificacionTipoDteDesc } = this.invoices[ index ];

                    // this.invoices[index].AmbienteToShow = dictionary[this.invoices[index].IdentificacionAmbiente];
                    this.invoices[index].InvoiceTotalPagarToShow = `${Currency}${numberWithCommas(this.invoices[index].InvoiceTotalPagar)}`;

                    // if( InvoiceType === 'TCKS' ) {
                    //     this.invoices[ index ].HorEmi = this.formatDateToHour(SystemDateInsert);
                    //     this.invoices[ index ].TipoDocumento = "TICKET";
                    // } else {
                    //     if( IdentificacionTipoDteDesc != null ) {
                    //         this.invoices[ index ].TipoDocumento = IdentificacionTipoDteDesc;
                    //     } else {
                    //         this.invoices[ index ].TipoDocumento = "";
                    //     }
                    //     if( IdentificacionHorEmi != null ) {
                    //         this.invoices[ index ].HorEmi = IdentificacionHorEmi;
                    //     } else { 
                    //         this.invoices[ index ].HorEmi = "";
                    //     }
                    // }
                    // {{ data.data.IdentificacionHorEmi != null ? data.data.IdentificacionHorEmi : "" }}
                    //     {{ data.data.InvoiceType === 'TCKS' ? formatDateToHour(data.data.SystemDateInsert) : "" }}
                }
            },
            getAllInvoices() {
                this.loading = true
                this.$API.invoices.getInvoicesPOSHistoryNotBilled(this.filter)
                    .then(response => {
                        this.loading = false
                        this.invoices = [...response]
                        this.formatInvoiceFields();
                    })
            },
            async showComandaModal (rowData) {
                this.orderAndPrint = true;
                await imprimirFactura(rowData.key, this);
                this.orderAndPrint = false;
            },
            async showInvoiceModal(rowData) {
                const invoiceData = rowData?.data

                if (!invoiceData || !invoiceData.ID_Invoice) {
                    return;
                }

                const params = {
                    ID_Branch: this.filter.ID_Branch,
                    ID_Business: this.filter.ID_Business,
                    ID_Invoice: invoiceData.ID_Invoice,
                };

                try {
                    this.loading = true;
                    const response = await this.$API.invoices.getInvoiceIsNotBilled(params);
                    this.loading = false;

                    console.log(response);

                    if (!response.value) {
                        this.showAlert(
                            'successWithCallback', 
                            'Advertencia',
                            'La factura seleccionada ya se encuentra procesada.',
                            {
                                alertAccept: async () => {
                                    await this.getAllInvoices();
                                    this.alert.show = false
                                }
                            },
                         );
                    } else {
                        this.showInvoice = rowData; 
                        this.showModal = true;
                    }


                } catch (err) {
                    console.log(err);
                    this.loading = false;
                }
            },
            filterHandler(response) {
                this.invoices = [...response];
                this.formatInvoiceFields();
            },
            hideModal() {
                this.showModal = false;
                this.showInvoice = null;
                this.getAllInvoices();
            },
            billNow() {
                this.hideModal();
                this.$emit('generateInvoice')
            },
            onExporting(e) {
                printToExcel(e, "Lista de Facturas")
            },
            showAlert(type, header, body, options = null) {
                type = type == null ? "warning" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;
            },
        }
    }
</script>

<style scoped>
.btn-add{
  background-color: #00A178 !important;
  color: white;
}

.filter-chip {
  cursor: pointer;
  margin: 4px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-chip:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.gap-2 {
  gap: 8px;
}
</style>